import React from 'react'
import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Paper from 'components/Paper'
import times from 'lodash-es/times'
import classNames from 'classnames'

export interface Props {
  count: number
  currentIndex: number
}

const styles = (theme: Theme) => createStyles({
  indicator: {
    width: 6,
    height: 6,
    marginLeft: 3,
    marginRight: 3,
    borderRadius: '100%'
  },
  activeIndicator: {
    backgroundColor: theme.palette.primary.main
  },
  inactiveIndicator: {
    backgroundColor: theme.palette.grey[50]
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const TutorialProgress: React.SFC<InjectedProps> = ({ count, currentIndex, classes }) => {
  return (
    <Grid container justify="center">
      {
        times(count, (i) => (
          <Grid item key={`indicator-${i}`}>
            <Paper
              className={classNames(
                classes.indicator,
                {
                  [classes.activeIndicator]: currentIndex === i,
                  [classes.inactiveIndicator]: currentIndex !== i,
                }
              )}
            />
          </Grid>
        ))
      }
    </Grid>
  )
}

export default withStyles(styles)(TutorialProgress)
